/* Montredo careers: employment-type filter for the open positions list. Safe to run more than once. */
(() => {
  const init = (root) => {
    if (root.dataset.montredoFiltersReady === 'true') return;
    root.dataset.montredoFiltersReady = 'true';

    root.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-montredo-filter]');
      if (!chip || !root.contains(chip)) return;

      const value = chip.dataset.montredoFilter;
      root.querySelectorAll('[data-montredo-filter]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === chip));
      });
      root.querySelectorAll('[data-employment]').forEach((row) => {
        row.hidden = value !== '' && row.dataset.employment !== value;
      });
    });
  };

  const scan = () => document.querySelectorAll('[data-montredo-job-list]').forEach(init);

  scan();
  if (!window.montredoJobFiltersListening) {
    window.montredoJobFiltersListening = true;
    document.addEventListener('shopify:section:load', scan);
  }
})();
